var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-panel",
    {
      staticClass: "q-form-container clearfix",
      attrs: { "header-text": _vm.formStructure.caption },
    },
    [
      _c(_vm.formStructure.staticFormKey, {
        tag: "component",
        attrs: { "form-structure": _vm.formStructure },
        model: {
          value: _vm.model,
          callback: function ($$v) {
            _vm.model = $$v
          },
          expression: "model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }